import checkout from "./form8";

const {
  formField8: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune,
    isFemale,
    sumFemale,
    confirmFemale,
    dateConfirmFemale,
    isMinority,
    sumMinority,
    confirmMinority,
    dateConfirmMinority,
    taxReductionFemale,
    taxReductionMinority
  },
} = checkout;

const initialValues8 = {
  [endow.name]: "",
  [departmentLevel.name]: "",
  [subordinateToTheDepartment.name]: "",
  [city.name]: "",
  [district.name]: "",
  [commune.name]: "",

  [isFemale.name]: false,
  [sumFemale.name]: "",
  [confirmFemale.name]: "",
  [dateConfirmFemale.name]: "",
  [isMinority.name]: false,
  [sumMinority.name]: "",
  [sumFemale.name]: "",
  [confirmMinority.name]: "",
  [dateConfirmMinority.name]: "",
  [taxReductionFemale.name]: false,
  [taxReductionMinority.name]: false,
};

export default initialValues8;
